const renderStoriesModal = () => {
   const pageBody = document.querySelector('body');
   const storiesModal = document.querySelector('.stories__modal');
   const modalImage = storiesModal?.querySelector('img');
   const modalName = storiesModal?.querySelector('h5');
   const modalCourse = storiesModal?.querySelector('b');
   const modalQuote = storiesModal?.querySelector('q');
   const blockquote = storiesModal?.querySelector('blockquote');

   const onCardClick = (evt) => {
      if (evt.target.closest('[data-modal-id="stories-modal"]')) {
         const modalContent = document.querySelector(".custom-modal__content");
         modalContent.classList.add("custom-modal__content--stories");
         const closeButtons = document.querySelectorAll("[data-modal-close]");
         closeButtons.forEach((button) => {
            button.addEventListener("click", () => modalContent.classList.remove("custom-modal__content--stories"))
         });
         const targetCard = evt.target.closest('.stories__slide');
         const blockquoteParagraphs = Array.from(targetCard.querySelectorAll('.stories__slide-hidden p')).map((paragraph) => paragraph.outerHTML);

         modalImage.src = targetCard.querySelector('img').src;
         modalName.textContent = targetCard.querySelector('h5').textContent;
         modalCourse.textContent = targetCard.querySelector('b').textContent;
         modalQuote.textContent = targetCard.querySelector('q').textContent;
         blockquote.innerHTML = blockquoteParagraphs.join(' ');
      }
   };

   storiesModal && pageBody.addEventListener('click', onCardClick);
};

export default renderStoriesModal;
